import { redirectTo, RouteComponentProps } from '@reach/router';
import React, { useEffect } from 'react';
import { Layout } from '../components';
import OrderContainer from '../containers/order-container';
import { AddOrderProvider } from '../context/add-order-context';
import { OrderFormProvider } from '../context/order-form-context';
import { ProviderProvider } from '../context/provider-context';
import { getToken } from '../lib/storage-util';

const Order: React.FC<RouteComponentProps> = () => {
  useEffect(() => {
    document.title = 'Sales Mediamyynti - New Order';
    const token = getToken();
    if (!token) {
      redirectTo('/');
    }
  }, []);

  return (
    <Layout tab="/order">
      <OrderFormProvider>
        <ProviderProvider>
          <AddOrderProvider>
            <OrderContainer></OrderContainer>
          </AddOrderProvider>
        </ProviderProvider>
      </OrderFormProvider>
    </Layout>
  );
};
export default Order;
